<script lang="ts" setup>
import { computed, defineProps, inject, ref } from "vue";
import SwitchBtn from "./SwitchBtn.vue";

const props = defineProps<{
  disabled?: boolean;
  modelValue: boolean;
  text: string;
}>();
const mode = inject("colormode", ref("white"));
const emit = defineEmits<(e: "update:modelValue", v: boolean) => void>();
const value = computed({
  get: () => props.modelValue,
  set: (val) => {
    if (!props.disabled) {
      emit("update:modelValue", val);
    }
  },
});
</script>

<template>
  <div class="switch-item" :class="{ disabled, [mode]: true }">
    <span class="switch-item-text">{{ text }}</span>
    <SwitchBtn v-model="value" :disabled="disabled" />
  </div>
</template>

<style scoped>
.switch-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 32px;
  user-select: none;
}

.switch-item.disabled {
  cursor: default;
}

.switch-item-text {
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.03px;
  text-align: left;
  color: #292929;
}

.black .switch-item-text {
  color: #ffffff;
}

.black.disabled .switch-item-text {
  color: #a4a4a4;
}
.white.disabled .switch-item-text {
  color: #a4a4a4;
}
</style>
